import '../../../styling/Styles.css';

const changePagePreviewMode = (comp, editor, setIndexPageFlow, setTriggeredButtonFlow) => {
  if ('core:preview' in editor.Commands.getActive()) {
    let targetPage = '';
    const selectedPage = localStorage.getItem('selectedPage');
    const selectedProject = localStorage.getItem('selectedProject');
    if (
      comp.model.attributes.attributes.target_page !== undefined &&
      comp.model.attributes.attributes.target_page !== ''
    ) {
      targetPage = comp.model.attributes.attributes.target_page;
    }
    let indexFlowPage = -1;
    if (selectedPage > -1 && selectedProject > -1) {
      const tempData = JSON.parse(localStorage.getItem('data'))[selectedProject].pages;
      tempData.forEach((page, index) => {
        if (page.pageId === targetPage) {
          indexFlowPage = index;
        }
      });
    }
    if (indexFlowPage > -1) {
      setIndexPageFlow(indexFlowPage);
      setTriggeredButtonFlow(true);
    }
    else if(
      comp.model.attributes.attributes.href !== undefined &&
      comp.model.attributes.attributes.href !== '' && 
      comp.model.attributes.attributes.href !== '#'
    ){
      if (editor.Commands.isActive('open-href-pop-up') === true) {
        editor.Commands.stop('open-href-pop-up');
        editor.runCommand('open-href-pop-up',{href: comp.model.attributes.attributes.href});
      }
      else{
        editor.runCommand('open-href-pop-up',{href: comp.model.attributes.attributes.href});
      }
    }
  }
};

// Thid functions loads all the custom made components and editable components to load in GrapesJs
const LoadComponents = (editor, setTriggeredButtonFlow, setIndexPageFlow) => {
      
  editor.DomComponents.getTypes().forEach( (type) => {
    const comps = editor.DomComponents;
    const defaultCustomType = comps.getType(type.id);
                
    comps.addType(type.id, {  
    extend: type.id,
    model: defaultCustomType.model.extend({}),
    view: defaultCustomType.view.extend({
      events: {
          dblclick: 'onActive',
          input: 'onInput',
          dragstart: 'handleDragStart',
          click () {
            changePagePreviewMode(this, editor, setIndexPageFlow, setTriggeredButtonFlow);
          }
        }
    })      
      
    });
    
  });
       

  // Change button component to have save properties with text component and to can edit inside content of it
  editor.DomComponents.addType('button', {
    model: {
      defaults: {
        tagName: 'button',
        classes: ['.pointer'], // Add click pointer on hover,
      }
    },
    extend: 'text',   
    isComponent: (el) => el.tagName === 'BUTTON' || el.type === 'BUTTON',
  });

  // Change link component to have save properties with text component and to can edit inside content of it
  editor.Components.addType('link', {
    isComponent: (el) => el.tagName === 'A' || el.type === 'LINK',
    extend: 'text',
    model: {
      defaults: {
        tagName: 'a',
        classes: ['.pointer'] // Add click pointer on hover
      }
    },
  });

  editor.Components.addType('image', {
    isComponent: (el) => el.tagName === 'IMAGE' || el.tagName === 'IMG',
    extend: 'image',
    model: {
      defaults: {
        classes: ['.pointer'] // Add click pointer on hover
      }
    }
  });

  // Make textarea component draggable to every place in canvas grapesJs
  editor.DomComponents.addType('textarea', {
    isComponent: (el) => el.tagName === 'TEXTAREA',
    extend: 'textarea',
    model: {
      defaults: {
        draggable: true,
      }
    }
  });

  const nameTrait = {
    name: 'name',
  };

  const requiredTrait = {
    type: 'checkbox',
    name: 'required',
  };

  // Make select component draggable to every place in canvas grapesJs
  editor.DomComponents.addType('select', {
    isComponent: (el) => el.tagName === 'SELECT',
    extend: 'select',
    model: {
      defaults: {
        enableEvents: false,
        draggable: true,
        layerable: true,
        droppable: true,
        highlightable: true,
        hoverable: true,
        selectable: true,
        editable: true,
        traits: [
          nameTrait,
          {
            name: 'options',
            type: 'select-options'
          },
          requiredTrait
        ]
      }
    }
  });

  
  editor.DomComponents.addType('option', {
    isComponent: el => el.tagName === 'OPTION',

    model: {
      defaults: {
        attributes:{
          dataitem: true
        },
        tagName: 'option',
        layerable: true,
        droppable: true,
        draggable: true,
        highlightable: true,
        hoverable: true,
        selectable: true,
        editable: true
      },
    },
    view: {
      events: {
        mousedown: e => e.preventDefault(),
      },
    },
  });


  editor.DomComponents.addType('checkbox', {
    isComponent: (el) => el.tagName === 'INPUT' && el.type === 'checkbox',
    extend: 'checkbox',
    model: {
      defaults: {
        draggable: true, // Make checkbox component draggable to every place in canvas grapesJs
        traits: [
          {
            name: 'checked',
            type: 'checkbox'
            // changeProp: 1,
          }
        ]
      }
    },

    view: {
      events: {},
      init() {
        this.listenTo(this.model, 'change:attributes:checked', this.handleChecked);
      },

      handleChecked() {
        this.el.checked = !!this.model.get('attributes').checked;
      }
    }
  });

  editor.DomComponents.addType('radio', {
    extend: 'checkbox',
    isComponent: (el) => el.tagName === 'INPUT' && el.type === 'radio',

    model: {
      defaults: {
        attributes: { type: 'radio' }
      }
    }
  });

  // Make form component droppable, it can now receives all components
  editor.DomComponents.addType('form', {
    extend: 'form',
    isComponent: (el) => el.tagName === 'FORM' || el.type === 'FORM',

    model: {
      defaults: {
        draggable: true,
        droppable: true
      }
    }
  });

  editor.DomComponents.addType('input', {
    isComponent: (el) => el.tagName === 'INPUT',
    model: {
      defaults: {
        draggable: true,
        traits: [
          // Strings are automatically converted to text types
          'name', // Same as: { type: 'text', name: 'name' }
          'placeholder',
          {
            type: 'select', // Type of the trait
            label: 'Type', // The label you will see in Settings
            name: 'type', // The name of the attribute/property to use on component
            options: [
              { id: 'text', name: 'Text' },
              { id: 'email', name: 'Email' },
              { id: 'password', name: 'Password' },
              { id: 'number', name: 'Number' },
              { id: 'string', name: 'String' }
            ]
          },
          {
            type: 'checkbox',
            name: 'required'
          }
        ],
        // As by default, traits are binded to attributes, so to define
        // their initial value we can use attributes
        attributes: { type: 'text', required: true }
      }
    }
  });

  editor.DomComponents.addType('custom-code', {
    extend: 'custom-code',
    isComponent: (el) => el.type === 'custom-code'
  });

  
  editor.DomComponents.addType('tableList', {
    isComponent: (el) => el.tagName === `table`,
    extend: 'table',
    model: {
      defaults: {
        type: 'tableList',
        tagName: 'table',
        editable: true
      }
    },
  });

  editor.DomComponents.addType('row', {
    isComponent: (el) => el.tagName === `ROW`,
    extend: 'row',
    model: {
      defaults: {
        type: 'row',
        tagName: 'div',
      }
    },
  });

  editor.DomComponents.addType('cell', {
    isComponent: (el) => el.type === `CELL` ,
    extend: 'cell',
    model: {
      defaults: {
        type: 'cell',
        tagName: 'div',
      }
    },
  });

  
  editor.DomComponents.addType('nav', {
    isComponent: (el) => el.type === `NAV` ,
    extend: 'default',
    model: {
      defaults: {
        type: 'nav',
        tagName: 'nav',
      }
    },
  });

  editor.DomComponents.addType('box', {
    isComponent: (el) => el.type === `BOX` ,
    extend: 'default',
    model: {
      defaults: {
        type: 'box',
        tagName: 'div',
      }
    },
  });

  editor.DomComponents.addType('footer', {
    isComponent: (el) => el.type === `FOOTER` ,
    extend: 'default',
    model: {
      defaults: {
        type: 'footer',
        tagName: 'footer',
      }
    },
  });

  editor.DomComponents.addType('p', {
    isComponent: (el) => el.type === `P` ,
    extend: 'text',
    model: {
      defaults: {
        type: 'p',
        tagName: 'p',
      }
    },
  });

  editor.DomComponents.addType('section', {
    isComponent: (el) => el.type === `SECTION` ,
    extend: 'default',
    model: {
      defaults: {
        type: 'section',
        tagName: 'section',
      }
    },
  });

  editor.DomComponents.addType('li', {
    isComponent: (el) => el.type === `LI` ,
    extend: 'text',
    model: {
      defaults: {
        type: 'li',
        tagName: 'li',
      }
    },
  });

  editor.DomComponents.addType('ol', {
    isComponent: (el) => el.type === `OL` ,
    extend: 'default',
    model: {
      defaults: {
        type: 'ol',
        tagName: 'ol',
      }
    },
  });

  editor.DomComponents.addType('ul', {
    isComponent: (el) => el.type === `UL` ,
    extend: 'default',
    model: {
      defaults: {
        type: 'ul',
        tagName: 'ul',
      }
    },
  });

  editor.DomComponents.addType('span', {
    isComponent: (el) => el.type === `SPAN` ,
    extend: 'default',
    model: {
      defaults: {
        type: 'span',
        tagName: 'span',
      }
    },
  });

};

export default LoadComponents;
